// Holds the active auth state for the current page load.
// Populated by main.ts before Phaser starts.

const STORAGE_KEY = "mythglade_jwt";
const DISPLAY_NAME_KEY = "mythglade_display_name";

export let activeJwt = "";
export let activeDisplayName = "";

export function setSession(jwt: string, displayName?: string): void {
  activeJwt = jwt;
  if (jwt) {
    sessionStorage.setItem(STORAGE_KEY, jwt);
  }
  if (displayName !== undefined) {
    activeDisplayName = displayName;
    sessionStorage.setItem(DISPLAY_NAME_KEY, displayName);
  }
}

/** Try to restore a non-expired JWT from sessionStorage. */
export function restoreSession(): boolean {
  const jwt = sessionStorage.getItem(STORAGE_KEY);
  if (!jwt) return false;

  // Check expiration
  try {
    const parts = jwt.split(".");
    if (parts.length < 2) return false;
    const payload = JSON.parse(atob(parts[1]!.replace(/-/g, "+").replace(/_/g, "/")));
    if (typeof payload.exp === "number" && payload.exp * 1000 < Date.now()) {
      sessionStorage.removeItem(STORAGE_KEY);
      return false;
    }
  } catch {
    sessionStorage.removeItem(STORAGE_KEY);
    return false;
  }

  activeJwt = jwt;
  activeDisplayName = sessionStorage.getItem(DISPLAY_NAME_KEY) ?? "";
  return true;
}

export function clearSession(): void {
  activeJwt = "";
  activeDisplayName = "";
  sessionStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(DISPLAY_NAME_KEY);
}
